import React, { Component } from 'react'

import _ from 'lodash'

import CopyrightContentDetectorPublishPreview from '../../../components/CopyrightContentDetectors/PublishPreview'

class CopyrightContentDetectorResult extends Component {
  render() {
    const publishUrl = _.get(this.props, 'location.query.publishUrl', '')

    return (
      <div className="copyright-content-detector-result">
        <CopyrightContentDetectorPublishPreview publishUrl={publishUrl} />
      </div>
    )
  }
}

export default CopyrightContentDetectorResult
